import { Tooltip } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

const SidebarItem = ({ url, title, imgSrc, isIco, active }) => {

  return (
    <li>
        <Link to={url} className={active ? 'active' : ''}>
            <Tooltip title={title} placement="right">
				{
					isIco ? imgSrc : <img src={imgSrc} alt={title} />
				}
            </Tooltip>
        </Link>
    </li>
  )
}

export default SidebarItem